const carouselSettings = {
  dots: false,
  arrows: true,
  swipeToSlide: true,
  initialSlide: 0,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default carouselSettings;
